export const SUPPORTED_LOCALES = ["en", "fr"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: SupportedLocale = "en";

/**
 * Translation files per locale, one per site section. They are composed into a
 * single i18next namespace, so keys stay section-prefixed: t("landing.hero.title").
 */
export const NAMESPACES = [
  "common",
  "landing",
  "seo",
  "fit",
  "work",
  "about",
  "processPage",
  "legal",
  "contact",
  "notFound",
] as const;

export function isLocale(value: string | undefined): value is SupportedLocale {
  return value !== undefined && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}
